var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
var ContentInformation = function (_a) {
    var mainContent = _a.mainContent;
    var contentRef = useRef(null);
    var isMobileViewport = window.visualViewport.width < 1024;
    useEffect(function () {
        // if (!isMobileViewport) {
        //   const tl = gsap.timeline();
        //   tl.from(contentRef.current, {
        //     opacity: 0.4,
        //     duration: 0.4,
        //     ease: Power2.easeInOut,
        //   }).from(
        //     contentRef.current,
        //     {
        //       y: 10,
        //       ease: Power2.easeInOut,
        //       duration: 0.8,
        //     },
        //     `<`,
        //   );
        // }
    }, []);
    return (_jsx("div", __assign({ className: "jobs__features__item__content flex w-full justify-start lg:justify-start" }, { children: _jsx("div", __assign({ className: "jobs__features__content__wrapper flex w-full flex-col lg:block", ref: contentRef }, { children: _jsx("span", __assign({ className: "jobs__features__content__text__wrapper flex max-w-full justify-start" }, { children: _jsx("p", __assign({ className: "max-w-full whitespace-pre-wrap break-words text-left font-normal text-white lg:text-base" }, { children: mainContent.content }), void 0) }), void 0) }), void 0) }), void 0));
};
export default ContentInformation;
